import { isValid, parseISO } from 'date-fns';

/**
 * Earthnode sends datetimes as `YYYY-MM-DD HH:MM:SS` (or a bare `YYYY-MM-DD`) with no offset, and they
 * are UTC. `new Date(value)` would read that as local time (and Safari rejects the space), so the value
 * is made an explicit UTC ISO string before parsing. Returns `null` for a value that doesn't parse, so
 * the caller renders no date rather than "Invalid Date".
 */
export default function parseUTCDateTime(value: string): Date | null {
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const parsed = parseISO(isDateOnly ? `${value}T00:00:00Z` : `${value.replace(' ', 'T')}Z`);

  return isValid(parsed) ? parsed : null;
}
